import { useAppSelector } from 'redux/hooks';

import { useUsersContext } from 'contexts/UsersContext';

import { EditForm } from 'sections/EditForm';
import { SectionType } from 'sections/TabWrap';

import { useDataForm } from './useDataForm.hooks';

const useData = () => {
  const { onSubmit, form, user } = useUsersContext();
  const priceList = useAppSelector((state) => state?.constants?.priceList);
  const userTypes = useAppSelector((state) => state?.constants?.userTypes);

  const formData = useDataForm(priceList, userTypes);

  const sections: SectionType[] = [
    {
      id: 1,
      content: (
        <EditForm
          submitBtnLabel="Create"
          hasButtons={!user}
          hideUndo
          errors={form?.formState?.errors}
          isDirty={form?.formState?.isDirty}
          onSubmit={onSubmit}
          data={formData}
          register={form?.register}
          control={form?.control}
          reset={form?.reset}
          initialValues={user}
        />
      ),
    },
  ];

  return {
    sections,
  };
};

export { useData };
